import InspectionChecklist from './InspectionChecklist';

export default InspectionChecklist;
